import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import SelectSeller from '@Components/Common/SelectSeller';
import H3FormInput from '@Uilib/h3FormInput';
import './style.scss';

const TransporterForm = ({ transporterId, setTransporterId, vehicleNumber, setVehicleNumber, transporterBillNumber, setTransporterBillNumber }) => {
  return (
    <div className="transporter-details__wrapper"
    >
      <div className="transporter-details__field">
        <span className="transporter-details__field-name">Select Transporter</span>
        <div className="transporter-details__field-value">
          <SelectSeller
            transporter
            selectedSeller={transporterId}
            onChange={(val) => {
              setTransporterId(val?.seller_id);
            }}
            containerClass=""
            inputClassName="select_row"
            labelClassName="orgFormLabel"
            hideTitle
            notRequired
            mapSellerId
          />
        </div>
      </div>

      <div className="transporter-details__field" style={{ margin: '5px 0px' }}>
        <span className="transporter-details__field-name">Vehicle Number</span>
        <div className="transporter-details__field-value">
          <H3FormInput
            value={vehicleNumber}
            type="string"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(e) => {
              setVehicleNumber(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="transporter-details__field" style={{ margin: '5px 0px' }}>
        <span className="transporter-details__field-name">Transporter Bill No.</span>
        <div className="transporter-details__field-value">
          <H3FormInput
            value={transporterBillNumber}
            type="string"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(e) => {
              setTransporterBillNumber(e.target.value);
            }}
          />
        </div>
      </div>

      <span style={{
        color: 'grey', fontStyle: 'italic', fontSize: '10px', fontWeight: '300',
      }}
      >
        The above freight charge is inclusive of tax. Expense will be created with respect to transporter
      </span>
    </div>
  )
}

const mapStateToProps = ({
  UserReducers
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
});

TransporterForm.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TransporterForm));
